import { ajax } from '@/api/ajax';

export interface CatalogBaseReq {
  brandCode?: string;
  region?: string;
}

export interface BrandSeriesModelListByBrandCodeResp {
  /**
   * 车系列表
   */
  seriesList?: SeriesResp[];
}
export interface SeriesResp {
  /**
   * 车型列表
   */
  modelList?: ModelResp[];
  /**
   * 车系编码
   */
  seriesCode?: string;
  /**
   * 车系名称
   */
  seriesName?: string;
}
export interface ModelResp {
  /**
   * 车型编码
   */
  modelCode?: string;
  /**
   * 车型名称
   */
  modelName?: string;
}

/**
 * @operationId brandSeriesModelListBySeriesCodeUsingPOST
 * @tags 车系车型查询
 * @logan http://logan-gateway.test.logan.xiaopeng.local/xp-ass-epc-cn-boot/doc.html#/EPC-%E7%9B%AE%E5%BD%95%E6%9F%A5%E8%AF%A2/EPC%E7%9B%AE%E5%BD%95%E6%9F%A5%E8%AF%A2/brandSeriesModelListBySeriesCodeUsingPOST
 */
export function brandSeriesModelListPost(data: CatalogBaseReq) {
  return ajax<BrandSeriesModelListByBrandCodeResp>({
    url: '/api/tis/web/bookmap/seriesModelList',
    method: 'post',
    data: data
  });
}
